import { formatWhen } from "./formatWhen";
import type { AgentSessionMeta } from "../../slices/ui";

// The chat list's attention markers (cas-commander): what the agent service computed for a row when it answered
// session.list (omega-ai-agent-service src/sessionGoal.ts classify). Only these six exist; "" or anything else has no marker.
const LABEL: Record<string, string> = {
  blocked: "Needs you", stalled: "Stopped", waiting: "Waiting", stuck: "Stuck", busy: "Working", done: "Done",
};
const COLOR: Record<string, "error" | "warning" | "info" | "success"> = {
  blocked: "error", stalled: "error", waiting: "warning", stuck: "warning", busy: "info", done: "success",
};
export const attentionLabel = (a: string | undefined): string | null => (a && LABEL[a]) || null;
export const attentionColor = (a: string | undefined): "error" | "warning" | "info" | "success" => (a && COLOR[a]) || "info";

const idPrefix = (s: AgentSessionMeta): string => s["session-id"].slice(0, 10);

// A row's first line: its title, else the time of its last message (as before).
export const rowTitle = (s: AgentSessionMeta, now: number): string => s.title || formatWhen(s["last-message-at"], now);

// A row's second line: the time and the id when it has a title, else the id alone (as before).
export const rowSubtitle = (s: AgentSessionMeta, now: number): string =>
  s.title ? [formatWhen(s["last-message-at"], now), idPrefix(s)].filter((p) => p !== "").join(" · ") : idPrefix(s);
